<template>
  <div class="controller-product-service-trying">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tiêu đề" prop="title">
          <a-input v-model="form.title" placeholder="Tiêu đề" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Mô tả" prop="description">
          <a-textarea
            :rows="4"
            v-model="form.description"
            placeholder="Mô tả"
          />
        </a-form-model-item>
        <a-form-model-item class="mb-30" label="Ảnh" :colon="false">
          <input
            type="file"
            accept="image/png, image/svg, image/jpeg, image/gif, image/jpg"
            @change="onAvatarChange"
          />
        </a-form-model-item>
        <img
          v-show="avatarUrl"
          id="preview-avatar"
          :src="avatarUrl"
          class="preview-avatar"
        />
        <a-form-model-item>
          <a-row type="flex" justify="end">
            <a-button
              type="primary"
              :loading="callingAPI"
              @click="handleSubmit"
            >
              {{ $route.params.id ? "Cập nhật" : "Thêm mới" }}
            </a-button>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import { createProductService, updateProductService, fetchProductServiceById } from '@/services/landing-page/home/product-service-trying'
import { replaceUrlResource } from '@/utils/common'
  export default {
    name: 'ControllerProductyServiceTrying',
    data() {
      return {
        callingAPI: false,

        form: {
          title: '',
          description: '',
          image: null,
          status: 1,
        },
        rules: {
          title: [
            { required: true, message: 'Giá trị không được để trống.', trigger: ['blur', 'change'] },
          ],
          description: [
            { required: true, message: 'Giá trị không được để trống.', trigger: ['blur', 'change'] },
          ],
          keyword: [
            { required: true, message: 'Giá trị không được để trống.', trigger: ['blur', 'change']  }
          ]
        },

        avatarUrl: "",
      }
    },
    async beforeMount() {
      if (this.$route.params.id) {
        await this.loadData()
      }
    },
    methods: {
      async loadData() {
        try {
          const response = await fetchProductServiceById(this.$route.params.id)
          this.form.title = response.data.title
          this.form.description = response.data.description
          this.form.status = response.data.status

          this.avatarUrl = replaceUrlResource(response.data.image)
        } catch (error) {
          
        }
      },
       onAvatarChange(e) {
        if (e.target.files.length) {
          const file = e.target.files[0];
          this.form.image = file;
          this.avatarUrl = URL.createObjectURL(file);
        }
      },
      handleSubmit(e) {
        e.preventDefault();
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              this.callingAPI = true

              const formData = new FormData()
              formData.append('title', this.form.title)
              formData.append('description', this.form.description)
              formData.append('keyword', this.form.keyword)
              formData.append('status', this.form.status)

              if (this.form.image) {
                formData.append('image', this.form.image)
              }

              if (this.$route.params.id) {
                formData.append('_method', 'PUT')
              }

              let response = null;
              if (this.$route.params.id) {
                 response = await updateProductService(this.$route.params.id, formData)
              } else {
                 response = await createProductService(formData)
              }
              if (response.status == 1) {
                const message = this.$route.params.id
                  ? "Cập nhật thành công."
                  : "Thêm mới thành công.";
                this.$notification.success({
                  message: "Thành công",
                  description: message,
                });
                this.$router.push({ name: "HomeProductServiceTrying" });
              } else {
                this.$notification.error({
                  message: "Thất bại",
                  description: response.errors[0],
                });
              }
            } catch (error) {
              this.callingAPI = false
              console.log(error);
            }
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
#preview-avatar {
  max-width: 100%;
  object-fit: contain;
  display: block;
}
</style>